import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  InputNumber,
  Table,
  Button,
  Typography,
  Tooltip,
  Empty,
  Select,
  Checkbox,
  Switch,
} from 'antd';

import {
  AFS_GROUP,
  ALTERNATIVES_GROUP,
  AssetGroupAllocationPayload,
  BONDS_GROUP,
  CASH_APPROACH,
  CASH_GROUP,
  CDS_GROUP,
  createUpdateGroupAllocations,
  CRYPTO_GROUP,
  EQUITIES_GROUP,
  FX_GROUP,
  GROUP_ASSET_NAME,
  HISTORICAL_SCENARIO,
  HTM_GROUP,
  MANAGEMENT_TYPES,
  PORTFOLIO_MANAGEMENT,
  REPO_GROUP,
  selectors,
  toggleInvestmentRationale,
  toggleSound,
  updateHistoricalStep,
  updateInvestmentProfile,
  WEALTH_MANAGEMENT,
} from 'state';
import { red } from '@ant-design/colors';
import { InfoCircleOutlined } from '@ant-design/icons';
import { hasCDSGroup, hasRepoGroup } from '../../../state/app/selectors';

type State = {
  [assetGroup: number]: AssetGroupAllocationPayload;
};

const GeneralSetup: React.FC = () => {
  const dispatch = useDispatch();
  const session = useSelector(selectors.activeSession);

  const [time, setTime] = useState<number>(session.historical_sleep_time);

  return (
    <div style={{ minWidth: 280 }}>
      <Typography.Title level={4} style={{ display: 'inline-block' }}>
        General Setup
      </Typography.Title>

      {/*-------------  TIME INTERVAL ------------- */}
      {session.scenario_type === HISTORICAL_SCENARIO && (
        <div style={{ display: 'flex', gap: 10 }}>
          <Typography.Text type={'secondary'} style={{ marginTop: '5px' }}>
            Time interval:
          </Typography.Text>
          <InputNumber
            style={{ width: '75px' }}
            placeholder={'Seconds'}
            value={time}
            onChange={value => {
              if (value !== undefined) {
                setTime(value);
              }
            }}
          />
          <Button
            onClick={() => {
              dispatch(
                updateHistoricalStep({
                  session_id: session.id,
                  sleep_time: time,
                  admin: false,
                })
              );
            }}
          >
            Save
          </Button>
        </div>
      )}

      {/*---------- Investment Rationale -------------*/}
      <div style={{ display: 'flex', gap: 10, marginTop: '15px' }}>
        {/*<Typography.Text type={'secondary'} style={{ marginTop: '5px' }}>*/}
        <Typography.Text type={'secondary'}>
          Require investment rationale:
        </Typography.Text>
        {/*<Checkbox*/}
        {/*  checked={session.require_investment_rationale}*/}
        {/*  onChange={e => {*/}
        {/*    dispatch(*/}
        {/*      toggleInvestmentRationale({*/}
        {/*        require_investment_rationale: e.target.checked,*/}
        {/*      })*/}
        {/*    );*/}
        {/*  }}*/}
        {/*/>*/}
        <Switch
          checked={session.require_investment_rationale}
          onChange={e => {
            dispatch(
              toggleInvestmentRationale({
                require_investment_rationale: e,
              })
            );
          }}
          // size="small"
        />
        {/*  Require investment rationale*/}
        {/*</Checkbox>*/}
      </div>

      {/*---------- Allow Sound -------------*/}
      <div style={{ display: 'flex', gap: 10, marginTop: '15px' }}>
        {/*<Typography.Text type={'secondary'} style={{ marginTop: '5px' }}>*/}
        <Typography.Text type={'secondary'}>Allow sound:</Typography.Text>
        {/*<Checkbox*/}
        {/*  checked={session.require_investment_rationale}*/}
        {/*  onChange={e => {*/}
        {/*    dispatch(*/}
        {/*      toggleInvestmentRationale({*/}
        {/*        require_investment_rationale: e.target.checked,*/}
        {/*      })*/}
        {/*    );*/}
        {/*  }}*/}
        {/*/>*/}
        <Switch
          checked={session.allow_sound}
          onChange={e => {
            dispatch(toggleSound({ allow_sound: e }));
          }}
          // size="small"
        />
        {/*  Require investment rationale*/}
        {/*</Checkbox>*/}
      </div>
    </div>
  );
};

export default GeneralSetup;
